import React from "react";
import { Flex, Skeleton, Spinner } from "@chakra-ui/react";

function DashboardCardSpinner() {
  return (
    <Flex
      width={"100%"}
      height={"100%"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Spinner color={"#1272EF"} width={"30px"} height={"30px"} />
    </Flex>
  );
}

export default DashboardCardSpinner;
